<div class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary text-center w-[100%] cursor-pointer"
    [id]="'pagemodule' + content.id" [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }" [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
    <div>
        <div class="text-center text-md font-bold mb-2" [attr.style]="buildStyle('text', items[0].styles?.text)">
            {{ items[0].value.text }}
        </div>
        <div class="text-center text-md mb-5" [attr.style]="buildStyle('text', items[1].styles?.text)"
            [innerHTML]="items[1].value.text | lineBreak">
        </div>

        <div>
            <div class="mb-2">
                <input [(ngModel)]="firstname" pInputText class="w-[100%]" type="text"
                    [placeholder]="items[2].value.label" />
            </div>
            <div class="mb-2">
                <input [(ngModel)]="lastname" pInputText class="w-[100%]" type="text"
                    [placeholder]="items[3].value.label" />
            </div>
            <div class="mb-2">
                <input [(ngModel)]="email" pInputText class="w-[100%]" type="text"
                    [placeholder]="items[4].value.label" />
            </div>
            <div class="mb-2">
                <input [(ngModel)]="phone" pInputText class="w-[100%]" type="number"
                    [placeholder]="items[5].value.label" />
            </div>
            <div class="mb-2">
                <textarea [(ngModel)]="message" pInputTextarea class="w-[100%] resize-none" rows="3"
                    [placeholder]="items[6].value.label"></textarea>
            </div>
        </div>

        @for (button of filter(items, 'type', 'button'); track button) {
        <div class="mb-2">
            <button (click)="submitForm()" pButton class="w-[100%] !border-none transition-all duration-200"
                [disabled]="firstname === '' || lastname === '' || email === '' || message === '' || phone === ''"
                [attr.style]="buildStyle('button', button.styles?.button)">
                {{ button.value.label }}
            </button>
        </div>
        }
    </div>
</div>